var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryStreak = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 87.45 49.57",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "streak-gradient-1",
    x1: 0,
    y1: 24.78,
    x2: 87.45,
    y2: 24.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ed2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f04b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f15a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f47730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f79037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f9a23c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#faac3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ed32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "streak-gradient-2",
    x1: 53.37,
    y1: 28.16,
    x2: 79.69,
    y2: 28.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ed2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f04b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f15a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f47730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f79037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f9a23c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#faac3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb040"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,7.88c-3.69-1.02-7.33-1.6-10.85-1.91-6.03-1.41-12.12-.94-15.57-5.96,0,0-.65,2.14,1.63,5.73-1.32,.04-2.6,.09-3.82,.12-6.49,.19-14.22,3.15-16.49,4.61-2.64,1.71-3.47,2.79-5.41,4.24-2.36,1.75-6.1,3.69-12.09,4.22,2.91,1.8,5.19,2.03,6.71,1.94,2.53-.16,3.68-1.3,6.52-1.52,2.45-.19,4.49,.43,5.78,.94-3.06,.31-7.08,1.25-10.45,4.14-3.1,2.66-3.44,5.08-6.46,7.28-2.09,1.53-5.51,2.98-11.27,2.49,.46,.81,1.32,2.07,2.8,3.09,1.36,.94,2.86,1.41,4.66,1.61,5.56,.62,7.87-2,12.97-2.03,1.79,0,4.38,.3,7.52,1.85-1.31-.18-6.38-.74-10.99,2.55-2.38,1.69-3.71,3.75-4.41,5.05,2.26-.84,4.91-1.41,7.84-1.2,2.1,.15,4.1,1.07,8.21,2.24,6.45,1.83,12.51-2.79,19.57-2.18-1.08,.61-2.27,1.65-2.77,3.44,0,0,3.03-2.68,11.25-.66,.57,.19,1.14,.37,1.7,.52,.56,.18,1.12,.34,1.7,.48,2.08,.61,4,.74,5.75,.55,9.54-.04,17.43-5.44,20.28-13.81,4.89-14.35-4.05-24.98-14.3-27.8Z",
    style: {
      fill: "url(#streak-gradient-1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.53,
    cy: 28.16,
    r: 17.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.43,17.15c-.45,0-.81-.36-.81-.81v-.63c0-.45,.36-.81,.81-.81s.81,.36,.81,.81v.63c0,.45-.36,.81-.81,.81Zm13.27,11.01c0-.45-.36-.81-.81-.81h-.63c-.45,0-.81,.36-.81,.81s.36,.81,.81,.81h.63c.45,0,.81-.36,.81-.81Zm-21.05-7.79c.32-.32,.32-.83,0-1.15l-.45-.45c-.32-.32-.83-.32-1.15,0-.32,.32-.32,.83,0,1.15l.45,.45c.16,.16,.37,.24,.57,.24s.42-.08,.57-.24Zm17.17,17.17c.32-.32,.32-.83,0-1.15l-.45-.45c-.32-.32-.83-.32-1.15,0-.32,.32-.32,.83,0,1.15l.45,.45c.16,.16,.37,.24,.57,.24s.42-.08,.57-.24Zm-.45-17.17l.45-.45c.32-.32,.32-.83,0-1.15s-.83-.32-1.15,0l-.45,.45c-.32,.32-.32,.83,0,1.15,.16,.16,.37,.24,.57,.24s.42-.08,.57-.24Zm-9.54,19.61v.63c0,.45,.36,.81,.81,.81s.81-.36,.81-.81v-.63c0-.45-.36-.81-.81-.81s-.81,.36-.81,.81Zm-12.45-11.82c0,.45,.36,.81,.81,.81h.63c.45,0,.81-.36,.81-.81s-.36-.81-.81-.81h-.63c-.45,0-.81,.36-.81,.81Zm4.33,7.79l-.45,.45c-.32,.32-.32,.83,0,1.15s.83,.32,1.15,0l.45-.45c.32-.32,.32-.83,0-1.15-.16-.16-.37-.24-.57-.24s-.42,.08-.57,.24Zm13.19-5.3c0-.41-.33-.74-.74-.74h-4.06v-7.81c0-.41-.33-.74-.74-.74s-.74,.33-.74,.74v8.55c0,.41,.33,.74,.74,.74h4.8c.41,0,.74-.33,.74-.74Z",
    style: {
      fill: "url(#streak-gradient-2)"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryStreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Streak.0638becf.svg";
export { ForwardRef as ReactComponent };